<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <Banner :title="`Cookie Declaration`"/>
                <div class='maxw-890 ma-0-auto pl-25 pr-25'>
                    <div id='cookiedeclaration'></div>
                </div>
            </template>
        </NuxtLayout>
    </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
// import DefaultLayout from '../../components/globals/layout/DefaultLayout'
import Banner from '~/components/sections/SectionBannerTitle/BannerTitle'
// import { useHead } from '@vueuse/head'
import {onMounted/*, computed, ref*/ } from 'vue'
// import Metadata from '~/assets/meta_data.json'

export default {
  name: 'cookie-declaration',
  components: {
    /*DefaultLayout,*/
    Banner
  },
  setup() {
    // const route = useRoute()
    // const runtime = useRuntimeConfig()
    // const metaData = ref(Metadata);
    onMounted(() => {
      debounceAmplitudeScriptTracking("View Cookie Declaration")
    })
    // useHead({
    //   title: computed(() => {
    //     const title = metaData.value.cookie_declaration.title
    //     return title
    //   }),
    //
    //   meta: computed(() => {
    //     const title = metaData.value.cookie_declaration.title
    //     const description = metaData.value.cookie_declaration.description
    //     return [
    //       {
    //         name: `title`,
    //         content: title,
    //       },
    //       {
    //         name: `description`,
    //         content: description,
    //       }
    //     ]
    //   }),
    //   link: computed(() => {
    //     return [
    //       { rel: 'canonical', href: `${runtime.public.publicDomain}${route.fullPath}`}
    //     ]
    //   }),
    // })
  },
  mounted() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://consent.cookiebot.com/9a41c88a-8b0c-4cef-bbaa-434b27800dab/cd.js')
    externalScript.setAttribute('id', 'CookieDeclaration')
    externalScript.setAttribute('type', 'text/javascript')
    externalScript.setAttribute('data-blockingmode', 'auto')
    document.getElementById('cookiedeclaration').appendChild(externalScript)
  }
}
</script>
<style lang='scss'>
#cookiedeclaration a {
  text-decoration: underline!important;
  color: black!important;
}
</style>

